export const REQUIRED_VALIDATION_MSG = 'Please fill required details';
